import { connect } from 'react-redux';
import { searchEmployees, updateSearchCriteria } from '../../../redux/searchEmployees';
import {updateSelectedEmployeeList} from '../../../redux/calendar';
import AvailableEmployees from './AvailableEmplyees';
import { distinctStandardCrews } from '../../../redux/standardCrews';


const mapStateToProps = (state) => ({    
   ...state.searchEmployees,
   ...state.events,
   standardcrews: distinctStandardCrews(state),
   date:state.calendar.date,
   form: state.searchEmployees.form,
   entity:state.settings.entity      
});

const mapDispatchToProps = {
  
    onEmployeeSearch: searchEmployees,   
    onFormUpdate: updateSearchCriteria,
    updateSelectedEmployeeList: updateSelectedEmployeeList,
        
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableEmployees);
